import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SectionTitle } from "features/SectionTitle";
import DisciplineRow from "./DisciplineRow";

const columnHeaders = [
  { label: "Дисциплина", md: 4 },
  { label: "Лекции", md: 1 },
  { label: "Упражнения", md: 1 },
  { label: "Българи (EUR)", md: 2 },
  { label: "Чужденци (EUR)", md: 2 },
  { label: "Действия", md: 2 },
];

const PriceSection = ({ title, periodLabel, periods, buildUrl, onSaved }) => {
  if (!periods?.length) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <SectionTitle
        title={title}
        paddingY={1}
      />
      {periods.map((period, idx) => (
        <Accordion
          key={period.period}
          defaultExpanded={idx === 0}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: "bold" }}>
              {periodLabel} {period.period}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              container
              spacing={1}
              sx={{ display: { xs: "none", md: "flex" }, mb: 1 }}
            >
              {columnHeaders.map(header => (
                <Grid
                  item
                  key={header.label}
                  md={header.md}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "bold" }}
                  >
                    {header.label}
                  </Typography>
                </Grid>
              ))}
            </Grid>
            {period.disciplines.map(discipline => (
              <DisciplineRow
                key={discipline.disciplineId}
                row={{ ...discipline, period: period.period }}
                buildUrl={buildUrl}
                onSaved={onSaved}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default PriceSection;
